import { z } from 'my-zod'
import { changeLogEntryModel } from './change-log-entry-model'

export const changeLogEntrySystemView = changeLogEntryModel.augment({
  profileName: z.string(),
  profileEmail: z.string()
})

export type changeLogEntrySystemView = z.infer<typeof changeLogEntrySystemView>
